module.exports = __webpack_public_path__ + "static/media/logo.04f6798f.svg";